import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import "./index.scss";
import App from "./components/app";
import PerfectScrollbar from "react-perfect-scrollbar";
import { ToastContainer } from "react-toastify";
import { store } from "./store";

// Components
import Dashboard from "./components/dashboard";
// Category
import Productcategory from "./components/category";
import AddCategory from "./components/category/create-category";
import List_user from "./components/users/list-user";
import Create_user from "./components/users/create-user";
import Profile from "./components/settings/profile";
import Reports from "./components/reports/report";
import Invoice from "./components/invoice";
import Datatable from "./components/common/datatable";
import Login from "./components/auth/login";
import AdminRoute from "./components/PrivateRoutes/adminRoute";
import AddBrand from "./components/brand/create-brand";
import Productbrand from "./components/brand";
import AddBox from "./components/box/create-box";
import Productbox from "./components/box";

import List_product from "./components/products/list-product";
import Create_product from "./components/products/create.product";
import Productrarity from "./components/products/rarityLevel";
import AddRaritylavel from "./components/products/rarityLevel/createRarity";

import Product_detail from "./components/products/product-detail";
import UserProfileDetails from "./components/users/user-profile-details";
import FundsManagement from "./components/fundManagement/funds";
import InventoryManagement from "./components/inventoryManagement";
import DepositeManagement from "./components/deposite/index";
import TeamManagement from "./components/teamManagement/TeamManagement";
import AddTeam from "./components/teamManagement/addTeam";
import UpdateTeam from "./components/teamManagement/updateTeam";
import ActivityLogList from "./components/activityLog/index";
import OrderDetail from "./components/orderpage/orderDetail";
import InvoiceDetail from "./components/orderpage/invoice";
import Bill from "./components/deposite/bill";
import { adminInstance } from "./config/axios";
import ShippingManagement from "./components/shippingManagement";
import Feedback from "./components/Feedback/Feedback";
import WinnerSocialProof from "./components/WinnerSocialProof/WinnerSocialProof";
import CreateVideoProof from "./components/WinnerSocialProof/CreateVideoProof";
import ReturnOrder from "./components/ReturnOrder/ReturnOrder";
import AffiliateLevelManagement from "./components/affiliate/levelManagement";
import AddAffiliateLevel from "./components/affiliate/addAffiliateLevel";
import AffiliateUserManagement from "./components/affiliate/affiliateUsers";
import AffiliateStats from "./components/affiliate/affiliatestats";
import TradeHistory from "./components/tradeHistory";
import Banner from "./components/Banner";
import CreateBanner from "./components/Banner/createBanner";

const Root = () => {
  const [newRole, setNewRole] = useState();
  const getAdminLoginData = async () => {
    try {
      const result = await adminInstance().get("api/admin/getAdminDetails");
      const { adminDetails } = result.data || {};
      const { role } = adminDetails || [];
      if (role?.length > 0) {
        setNewRole(role);
      }
    } catch (err) {
      console.log("Error is here-->", err);
    }
  };
  useEffect(() => {
    getAdminLoginData();
  }, []);

  return (
    <Provider store={store}>
      <BrowserRouter basename={"/"}>
        <PerfectScrollbar>
          <Switch>
            <Route exact path="/" component={Login} />
            <App newRole={newRole}>
              <Route path="/dashboard" component={Dashboard} />
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readBox",
                  "writeBox",
                  "delBox",
                ].includes(r)
              ) ? (
                <AdminRoute exact path="/create-box" component={AddBox} />
              ) : (
                <AdminRoute exact path="/create-box" component={Dashboard} />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readBox",
                  "writeBox",
                  "delBox",
                ].includes(r)
              ) ? (
                <AdminRoute exact path="/box-list" component={Productbox} />
              ) : (
                <AdminRoute exact path="/box-list" component={Dashboard} />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readBrand",
                  "writeBrand",
                  "delBrand",
                ].includes(r)
              ) ? (
                <AdminRoute exact path="/create-brand" component={AddBrand} />
              ) : (
                <AdminRoute exact path="/create-brand" component={Dashboard} />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readBrand",
                  "writeBrand",
                  "delBrand",
                ].includes(r)
              ) ? (
                <AdminRoute exact path="/brand-list" component={Productbrand} />
              ) : (
                <AdminRoute exact path="/brand-list" component={Dashboard} />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readCategory",
                  "writeCategory",
                  "delCategory",
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path="/category-list"
                  component={Productcategory}
                />
              ) : (
                <AdminRoute exact path="/category-list" component={Dashboard} />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readCategory",
                  "writeCategory",
                  "delCategory",
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path="/create-category"
                  component={AddCategory}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/create-category"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readProduct",
                  "writeProduct",
                  "delProduct",
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path="/products/view-product"
                  component={Product_detail}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/products/view-product"
                  component={Dashboard}
                />
              )}
              <AdminRoute exact path="/order-details" component={OrderDetail} />
              <AdminRoute
                exact
                path="/invoice-details"
                component={InvoiceDetail}
              />
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readUsers",
                  "writeUsers",
                  "delUsers",
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path="/users/list-user"
                  component={List_user}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/users/list-user"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readProduct",
                  "writeProduct",
                  "delProduct",
                ].includes(r)
              ) ? (
                <Route
                  exact
                  path="/users/create-user"
                  component={Create_user}
                />
              ) : (
                <Route exact path="/users/create-user" component={Dashboard} />
              )}
              <AdminRoute
                exact
                path="/products/list_product"
                component={List_product}
              />
              <AdminRoute
                exact
                path="/vendors/productList"
                component={List_product}
              />
              <AdminRoute
                exact
                path="/products/create-product"
                component={Create_product}
              />
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readWithdraws",
                  "writeWithdraws",
                  "delWithdraws",
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path="/funds-management"
                  component={FundsManagement}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/funds-management"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readOrders",
                  "writeOrders",
                  "delOrders",
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path="/order-management"
                  component={InventoryManagement}
                />
              ) : (
                <Route path="/order-management" component={Dashboard} />
              )}
              {newRole &&
              newRole?.some((r) => ["suUsers", "superAdmin"].includes(r)) ? (
                <AdminRoute
                  exact
                  path="/team-management"
                  component={TeamManagement}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/team-management"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) => ["suUsers", "superAdmin"].includes(r)) ? (
                <AdminRoute exact path="/addTeam" component={AddTeam} />
              ) : (
                <AdminRoute exact path="/addTeam" component={Dashboard} />
              )}
              {newRole &&
              newRole?.some((r) => ["suUsers", "superAdmin"].includes(r)) ? (
                <AdminRoute exact path="/updateTeam" component={UpdateTeam} />
              ) : (
                <AdminRoute exact path="/updateTeam" component={Dashboard} />
              )}
              <AdminRoute exact path="/reports/report" component={Reports} />
              {/* {newRole &&
								newRole?.some((r) =>
									[
										'suUsers',
										'superAdmin',
										'readSetting',
										'writeSetting',
										'delSetting',
									].includes(r)
								) && */}{" "}
              <AdminRoute
                exact
                path="/settings"
                component={Profile}
                // pathName={window.location.pathname}
                // newRole={newRole}
              />
              {/* } */}
              <AdminRoute exact path="/invoice" component={Invoice} />
              <AdminRoute exact path="/data-table" component={Datatable} />
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readProfile",
                  "writeProfile",
                  "delProfile",
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path="/user-profile-details"
                  component={UserProfileDetails}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/user-profile-details"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readRarityLevel",
                  "writeRarityLevel",
                  "delRarityLevel",
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path="/products/add-raritylevel"
                  component={AddRaritylavel}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/products/add-raritylevel"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readRarityLevel",
                  "writeRarityLevel",
                  "delRarityLevel",
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path="/products/rarity-list"
                  component={Productrarity}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/products/rarity-list"
                  component={Dashboard}
                />
              )}
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readActivityLog",
                  "writeActivityLog",
                  "delActivityLog",
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path="/activityLog"
                  component={ActivityLogList}
                />
              ) : (
                <AdminRoute exact path="/activityLog" component={Dashboard} />
              )}
              <AdminRoute exact path="/orderDetails" component={OrderDetail} />
              {newRole &&
              newRole?.some((r) =>
                [
                  "suUsers",
                  "superAdmin",
                  "readDelivery",
                  "writeDelivery",
                  "delDelivery",
                ].includes(r)
              ) ? (
                <AdminRoute
                  exact
                  path="/shippingManagement"
                  component={ShippingManagement}
                />
              ) : (
                <AdminRoute
                  exact
                  path="/shippingManagement"
                  component={Dashboard}
                />
              )}
              <AdminRoute
                exact
                path="/payment-history"
                component={DepositeManagement}
              />
              <AdminRoute
                exact
                path="/trade-history"
                component={TradeHistory}
              />
              <AdminRoute exact path="/deposite-details" component={Bill} />
              <AdminRoute exact path="/feedback" component={Feedback} />
              <AdminRoute
                exact
                path="/winners-social-proof"
                component={WinnerSocialProof}
              />
              <AdminRoute
                exact
                path="/banner-management"
                component={Banner}
              />
              <AdminRoute
                exact
                path="/add-banner"
                component={CreateBanner}
              />
              <AdminRoute
                exact
                path="/create-social-proof"
                component={CreateVideoProof}
              />
              <AdminRoute exact path="/return-order" component={ReturnOrder} />
              <AdminRoute
                exact
                path="/affiliate-level"
                component={AffiliateLevelManagement}
              />
              <AdminRoute
                exact
                path="/addAffiliateLevel"
                component={AddAffiliateLevel}
              />
              <AdminRoute
                exact
                path="/affiliate-users"
                component={AffiliateUserManagement}
              />
              <AdminRoute
                exact
                path="/affiliate-stats"
                component={AffiliateStats}
              />
            </App>
          </Switch>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </PerfectScrollbar>
      </BrowserRouter>
    </Provider>
  );
};

ReactDOM.render(<Root />, document.getElementById("root"));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
